import vuei18n from '@/plugins/i18n';
import router from '@/router'
import types from './types';
import Bugsnag from '@bugsnag/browser';
import { getFieldsByForm } from '@/utils/forms.utils'
import { camelizeKeys, decamelizeKeys } from 'humps';

import * as arcService from '@/services/v2/arc-api-v2.service'
import * as plansService from '@/services/v2/plans-api-v2.service'
import * as BeneficiaryLookupService from '@/services/v2/beneficiary-lookup-v2.service'

export const getAuthorizations = async ({ commit }, filters) => {
  commit(types.AUTHORIZATION_LOADING, true)
  try {
    const response = await arcService.getAuthorizationList(filters);
    let camelizeResponse = camelizeKeys(response.data);

    if(filters.orderBy === "coverageType"){
      camelizeResponse.content.sort((a,b)=> {

        let valueA = vuei18n.t(arcService.getType(a[filters.orderBy]));
        let valueB = vuei18n.t(arcService.getType(b[filters.orderBy]));

        if(filters.sort === "ASC"){
          return valueA > valueB ? 1 : valueA < valueB ? -1 : 0
        }
        if (filters.sort === "DESC"){
          return valueB > valueA ? 1 : valueB < valueA ? -1 : 0
        }

      });
    }

    commit(types.AUTHORIZATION_LOAD_SUCCESS, camelizeResponse)
    commit(types.AUTHORIZATION_LOADING, false)
  } catch (error) {
    commit(types.AUTHORIZATION_LOAD_ERROR)
    commit(types.AUTHORIZATION_LOADING, false)
  }
}

export const getAuthorizationsWithoutClaims = async ({ commit, rootState }, filters) => {
  commit(types.AUTHORIZATION_LOADING, true)
  try {
    const tokenExtensions = rootState.auth.tokenExtensions;
    const sponsorSlug = tokenExtensions.sponsorSlug;

    const response = await arcService.getAuthorizationsWithoutClaim(filters, sponsorSlug)
    const data = camelizeKeys(response.data)
    commit(types.AUTHORIZATION_LOAD_SUCCESS, data)

  }catch(error){
    commit(types.AUTHORIZATION_LOAD_ERROR)

  }finally {
    commit(types.AUTHORIZATION_LOADING, false)
  }
}

export const getAuthorizationsForm = async ({ commit, rootState }) => {
  try {
    const tokenExtensions = rootState.auth.tokenExtensions;
    const sponsorSlug = tokenExtensions.sponsorSlug;
    const response = await arcService.getAuthorizationForm(sponsorSlug);
    const data = camelizeKeys(response.data)

    const formFields = getFieldsByForm(data)
    const formFieldsKeys = Object.keys(formFields)
    if (formFieldsKeys.length === 1 ) {
      formFields[formFieldsKeys[0]].shift()
      commit(types.SET_CURRENT_FORM, formFieldsKeys[0])
    }
    commit(types.AUTHORIZATION_FORM_LOAD_SUCCESS, { response: data, formsByStep: formFields })
    commit(types.AUTHORIZATION_LOADING, false)
  } catch (error) {
    commit(types.AUTHORIZATION_LOAD_ERROR)
    commit(types.AUTHORIZATION_LOADING, false)
  }
}

export const getSponsorConfiguration = async ({ commit, rootState}) => {
  try {
    const tokenExtensions = rootState.auth.tokenExtensions;
    const sponsorSlug = tokenExtensions.sponsorSlug;
    const response = await arcService.getSponsorConfiguration(sponsorSlug);
    const data = camelizeKeys(response.data)
    commit(types.AUTHORIZATION_SPONSOR, data)
  } catch (error) {
    commit(types.AUTHORIZATION_LOAD_ERROR)
    commit(types.AUTHORIZATION_LOADING, false)
  }
}

export const getBeneficiary = async ({ commit, rootState }) => {
  try {
    const beneficiaryId = rootState.auth.tokenExtensions.beneficiaryId;
    const sponsorResponse = await plansService.getBeneficiary(beneficiaryId);
    const beneficiary = camelizeKeys(sponsorResponse.data)
    commit(types.SET_BENEFICIARY, beneficiary)
    commit(types.SET_SPONSOR_SLUG, beneficiary.sponsorSlug)
    commit(types.SET_COUNTRY_CODE, beneficiary.nationalityCountryCode)
    commit(types.SET_CURRENCY_CODE, beneficiary.currencyCode)
    sessionStorage.setItem('sponsorSlug', beneficiary.sponsorSlug)
    sessionStorage.setItem('countryCode', beneficiary.nationalityCountryCode)
    sessionStorage.setItem('currencyCode', beneficiary.currencyCode)
  } catch(error) {
    commit(types.SET_BENEFICIARY_ERROR, error)
  }
}

export const setCurrentForm = ({ commit, state, dispatch }, payload) => {
  const form = state.authorizationForms.find(form => form.formSlug === payload)
  dispatch('setIsReimbursement', form.reimbursement)
  commit(types.SET_CURRENT_FORM, payload)
}

export const setCurrentStep = ({ commit }, payload) => {
  commit(types.SET_CURRENT_STEP, payload)
}

export const setCurrentCoverage = ({ commit }, payload) => {
  commit(types.SET_CURRENT_COVERAGE, payload)
}

export const nextStep = ({ commit, state, dispatch, getters }, payload) => {
  dispatch('setError',{hasError: false, error: null})
  if (state.currentStep === payload) {
    const { authorizationForms, currentForm } = getters;
    const form = authorizationForms.find(form => form.formSlug === currentForm)
    if (form && !form.reimbursement) {
      dispatch('sendAuthorization')
    } else {
      dispatch('sendReimbursementV2')
    }

  } else {
    commit(types.SET_CURRENT_STEP, state.currentStep + 1)
  }
}

export const lastStep = ({ commit, state, dispatch }) => {
  if (state.currentStep === 1) {
    dispatch('resetAuthorizationState')
    router.push({ name: 'HomeV2'})
  } else {
    commit(types.SET_CURRENT_STEP, state.currentStep - 1)
    dispatch('setStepError',true);
    dispatch('setError',{hasError: false, error: null})
  }
}

export const sendReimbursement = async ({ commit, state, rootState, dispatch }) => {
  commit(types.AUTHORIZATION_LOADING, true)
  try {
    const beneficiaryId = rootState.auth.tokenExtensions.beneficiaryId;
    const request = decamelizeKeys({ beneficiaryId, formSlug: state.currentForm, inputs: state.inputs })
    const response = await arcService.sendReimbursement(request)
    const reimbursement = camelizeKeys(response.data)
    dispatch('sendReimbursementFiles', reimbursement.reimbursementId)
  } catch (error) {
    const response = error.response
    if (response) {
      let errorMessage = null
      const status = response.status
      if (status === 422) {
        const exceptionData = response.data
        if (exceptionData.errors) {
          if (exceptionData.errors.length > 0) {
            errorMessage = exceptionData.errors[0].message;
          }
        }
      } else if (status === 500) {
        const exceptionData = response.data
        errorMessage = exceptionData.message
      }

      dispatch('setError',{hasError: true, error: errorMessage})
    }
    commit(types.AUTHORIZATION_LOAD_ERROR)
    commit(types.AUTHORIZATION_LOADING, false)
  }
}

export const sendReimbursementV2 = async ({ commit, state, dispatch, rootState }) => {
  commit(types.AUTHORIZATION_LOADING, true)
  try {
    const beneficiaryId = rootState.auth.tokenExtensions.beneficiaryId;
    const files = state.files.map(file => file.fileId)
    const request = decamelizeKeys({ beneficiaryId, formSlug: state.currentForm, inputs: state.inputs, files })
    await arcService.sendReimbursementV2(request)
    commit(types.SET_CURRENT_STEP, 1)
    commit(types.AUTHORIZATION_LOADING, false)
    commit(types.RESET_AUTHORIZATION_STATE)
    dispatch('setReimbursementStatus', 'SUCCESS')
    router.push('/home')
  } catch (error) {
    const response = error.response
    if (response) {
      let errorMessage = null
      const status = response.status
      if (status === 422) {
        const exceptionData = response.data
        if (exceptionData.errors) {
          if (exceptionData.errors.length > 0) {
            errorMessage = exceptionData.errors[0].message;
          }
        }
      } else if (status === 500) {
        const exceptionData = response.data
        errorMessage = exceptionData.message
      }

      dispatch('setError',{hasError: true, error: errorMessage})
    }
    commit(types.AUTHORIZATION_LOAD_ERROR)
    commit(types.AUTHORIZATION_LOADING, false)
  }
}

export const sendReimbursementFiles = async ({ commit, state, rootState, dispatch }, reimbursementId) => {
  commit(types.AUTHORIZATION_LOADING, true)
  try {
    const filesByField = state.files;
    const beneficiaryId = rootState.auth.tokenExtensions.beneficiaryId;
    const userName = rootState.auth.tokenExtensions.userName;

    for (let i = 0; i < filesByField.length; i++) {

      const fieldFile = filesByField[i];
      const files = fieldFile.files;
      for (let j = 0; j < files.length; j++) {
        const file = files[j];
        await arcService.sendFile(fieldFile.fieldSlug, file, reimbursementId);
        Bugsnag.notify(new Error('sending files'), function (event) {
          event.severity = 'info'
          event.context = 'sending-files'
          event.addMetadata('reimbursement-detail', { reimbursementId, beneficiaryId, userName, file: fieldFile.fieldSlug })
        })
      }
    }
    dispatch('completeReimbursement', reimbursementId)
  } catch (error) {
    commit(types.AUTHORIZATION_LOAD_ERROR)
    dispatch('setReimbursementToErrorStatus', reimbursementId)
  }
}

export const setReimbursementToErrorStatus = async ({commit, dispatch}, reimbursementId) => {
  commit(types.AUTHORIZATION_LOADING, true)
  try{
    await arcService.setReimbursementToErrorStatus(reimbursementId);
    commit(types.SET_CURRENT_STEP, 1)
    commit(types.RESET_AUTHORIZATION_STATE)
    dispatch('setReimbursementStatus', 'ERROR')
    router.push('/home')
  }catch(error){
    commit(types.AUTHORIZATION_LOAD_ERROR)
    commit(types.AUTHORIZATION_LOADING, false)
  }
}

export const completeReimbursement = async ({ commit, dispatch }, reimbursementId) => {
  commit(types.AUTHORIZATION_LOADING, true)
  try {
    await arcService.completeReimbursement(reimbursementId)
    commit(types.SET_CURRENT_STEP, 1)
    commit(types.AUTHORIZATION_LOADING, false)
    commit(types.RESET_AUTHORIZATION_STATE)
    dispatch('setReimbursementStatus', 'SUCCESS')
    router.push('/home')
  } catch (error) {
    const response = error.response
    if (response) {
      let errorMessage = null
      const status = response.status
      if (status === 422) {
        const exceptionData = response.data
        if (exceptionData.errors) {
          if (exceptionData.errors.length > 0) {
            errorMessage = exceptionData.errors[0].message;
          }
        }
      } else if (status === 500) {
        const exceptionData = response.data
        errorMessage = exceptionData.message
      }

      dispatch('setError',{hasError: true, error: errorMessage})
    }
    commit(types.AUTHORIZATION_LOAD_ERROR)
    commit(types.AUTHORIZATION_LOADING, false)
    dispatch('setReimbursementToErrorStatus', reimbursementId)
  }
}

export const sendAuthorization = async ({ commit, state, dispatch }) => {
  commit(types.AUTHORIZATION_LOADING, true)
  try {
    const beneficiaryId = state.searchBeneficiaries.selectedBeneficiary.id;
    const request = decamelizeKeys({ beneficiaryId, formSlug: state.currentForm, inputs: state.inputs })
    const response = await arcService.sendAuthorization(request)
    const authorization = camelizeKeys(response.data)
    dispatch('sendAuthorizationFiles', authorization.id)
  } catch(error) {
    commit(types.AUTHORIZATION_LOAD_ERROR)
    commit(types.AUTHORIZATION_LOADING, false)
  }
}

export const sendAuthorizationFiles = async ({ commit, state, dispatch }, authorizationId) => {
  commit(types.AUTHORIZATION_LOADING, true)
  try {
    const filesByField = state.files;

    for (let i = 0; i < filesByField.length; i++) {

      const fieldFile = filesByField[i];
      const files = fieldFile.files;
      for (let j = 0; j < files.length; j++) {
        const file = files[j];
        await arcService.sendAuthorizationFile(fieldFile.fieldSlug, file, authorizationId);
      }
    }
    dispatch('completeAuthorization', authorizationId)
  } catch (error) {
    commit(types.AUTHORIZATION_LOAD_ERROR)
    dispatch('setAuthorizationToErrorStatus', authorizationId)
  }
}

export const setAuthorizationToErrorStatus = async ({commit, dispatch}, authorizationId) => {
  commit(types.AUTHORIZATION_LOADING, true)
  try{
    await arcService.setAuthorizationToErrorStatus(authorizationId);
    commit(types.SET_CURRENT_STEP, 1)
    commit(types.RESET_AUTHORIZATION_STATE)
    dispatch('setReimbursementStatus', 'ERROR')
    router.push('/home')
  }catch(error){
    commit(types.AUTHORIZATION_LOAD_ERROR)
    commit(types.AUTHORIZATION_LOADING, false)
  }
}

export const completeAuthorization = async ({ commit, dispatch }, authorizationId) => {
  commit(types.AUTHORIZATION_LOADING, true)
  try {
    await arcService.completeAuthorization(authorizationId)
    commit(types.SET_CURRENT_STEP, 1)
    commit(types.AUTHORIZATION_LOADING, false)
    commit(types.RESET_AUTHORIZATION_STATE)
    dispatch('setReimbursementStatus', 'SUCCESS')
    router.push('/')
  } catch (error) {
    commit(types.AUTHORIZATION_LOAD_ERROR)
    commit(types.AUTHORIZATION_LOADING, false)
  }
}

export const setError = ({ commit }, payload) => {
  commit(types.SET_ERROR, payload);
}

export const setDetailFiles = ({ commit }, payload) => {
  commit(types.ADD_FILES, payload)
}

export const setFiles = async ({ commit, state }, payload) => {
  commit(types.SET_LOADING_FILE, true)
  try {
    const fieldFiles = Array.from(payload.files)
    for (let i = 0; i < fieldFiles.length; i++) {
      const file = fieldFiles[i]
      const formSlug = state.currentForm
      const uploadedFile = await arcService.sendFileV2(formSlug, payload.fieldSlug, file)
      const responseData = camelizeKeys(uploadedFile.data)
      responseData.files = [file]
      state.files.push(responseData)
    }

    commit(types.ADD_FILES, state.files)
    commit(types.SET_LOADING_FILE, false)
  } catch (error) {
    commit(types.SET_LOADING_FILE, false)
    commit(types.AUTHORIZATION_LOAD_ERROR)
  }
}

export const removeFile = ({ commit }, id) => {
  commit(types.REMOVE_FILE, id)
}

export const setStepError = ({ commit }, payload) => {
  commit(types.SET_STEP_ERROR, payload)
}

export const setInput = ({ commit, state }, payload) => {
  const { slug, value } = payload;
  const inputs = state.inputs;
  const index = inputs.findIndex(input => input.slug === slug);
  if (index >= 0) {
    inputs[index].value = value;
  } else {
    inputs.push({ slug, value });
  }

  commit(types.SET_INPUTS, inputs)
}

export const removeInput = ({ commit, state }, payload) => {
  const inputs = state.inputs;
  const inputsFiltered = inputs.filter(input => input.slug != payload)
  commit(types.SET_INPUTS, inputsFiltered)
}

export const setReimbursementStatus = ({ commit }, payload) => {
  commit(types.SET_REIMBURSEMENT_STATUS, payload)
}

export const setClaimType = ({ commit }, payload) => {
  commit(types.SET_CLAIM_TYPE, payload)
}

export const resetAuthorizationState = ({ commit }) => {
  commit(types.RESET_AUTHORIZATION_STATE)
}

export const setSingleAuthorization = async ({ commit }, payload) => {
  sessionStorage.setItem('listAuthorization', JSON.stringify(payload))
  commit(types.SET_LIST_AUTHORIZATION, payload)
  commit(types.SET_AUTHORIZATION, {})
}

export const getAuthorizationDetail = async ({ commit, rootState, dispatch, state }, payload) => {
  try {
    const sponsorSlug = rootState.auth.tokenExtensions.sponsorSlug;

    const { statusConfiguration, iconConfiguration, type } = state.listAuthorization || {}

    const authorizationResponse = await arcService.getAuthorization(sponsorSlug, payload)

    let authorization = camelizeKeys(authorizationResponse.data)
    authorization = {
      ...authorization,
      statusLabel: arcService.getStatus(authorization),
      statusConfiguration, iconConfiguration, type
    }

    sessionStorage.setItem('authorization', JSON.stringify(authorization))

    commit(types.SET_AUTHORIZATION, authorization)
    commit(types.AUTHORIZATION_COMMENT_LOADING, false);
    dispatch('setIsReimbursement', authorization.isReimbursement)

    if (!state.authorizationFormsAndSteps) {
      dispatch('getAuthorizationsForm')
    }
  } catch(error) {
    commit(types.SET_AUTHORIZATION_ERROR, error)
    commit(types.AUTHORIZATION_COMMENT_LOADING, false);
    router.push('/home')
  }
}

export const sendReimbursementFilesWithComment = async ({ commit, state, dispatch, getters }) => {
  commit(types.AUTHORIZATION_LOADING, true)

  const filesByField = state.files;
  const commentFiles = [];
  for (let i = 0; i < filesByField.length; i++) {

    const fieldFile = filesByField[i];
    const files = fieldFile.files;
    for (let j = 0; j < files.length; j++) {
      const file = files[j];
      const commentFile = { name: file.name, type: file.type}
      commentFiles.push(commentFile)
      const { authorization } = getters;
      if (authorization.isReimbursement) {
        await arcService.sendFile(fieldFile.fieldSlug, file, authorization.reimbursementId);
      } else {
        await arcService.sendAuthorizationFile(fieldFile.fieldSlug, file, authorization.authorizationId);
      }
    }
  }

  const metadataCommentDecamelize = decamelizeKeys({ fallbackLabel: filesByField[0].fallbackLabel, slug: filesByField[0].fieldSlug, commentFiles})
  const metadataComment = JSON.stringify(metadataCommentDecamelize)
  const comment = vuei18n.t('authorizationDetail.observations.addOtherFileComment')
  const payload = decamelizeKeys({ comment, privateComment: false, beneficiaryComment: true, metadataComment })

  dispatch('sendComment', payload)
  commit(types.AUTHORIZATION_LOADING, false)
}

export const sendBeneficiaryComment = async ({ commit, state, dispatch}, payload) => {
  commit(types.AUTHORIZATION_COMMENT_LOADING, true)
  const comment = decamelizeKeys({ comment: payload, privateComment: false, beneficiaryComment: true })
  await dispatch('sendComment', comment);
  const authorizationCode = state.authorization.authorizationCode;
  await dispatch('getAuthorizationDetail', authorizationCode);
}

export const sendComment = async ({ state }, payload) => {
  await arcService.sendComment(state.authorization.authorizationCode, payload)
}

export const setIsReimbursement = ({ commit }, payload) => {
  commit(types.SET_IS_REIMBURSEMENT, payload)
}

export const getBeneficiarySponsorForms = async ({ commit, dispatch }, payload) => {
  try{
    const response = await BeneficiaryLookupService.getSponsorForms(payload)
    const data = camelizeKeys(response.data)
    commit(types.SET_SEARCH_BENEFICIARY_SPONSOR_FORMS, data)
  }catch(error){
    dispatch('setError',{hasError: true, error: 'Error al cargar los formularios de busqueda de beneficiarios'})
  }
}

export const searchBeneficiaries = async ({ commit, dispatch }, {sponsorSlug, payload}) => {
  try{
    const response = await BeneficiaryLookupService.searchBeneficiaries(sponsorSlug, decamelizeKeys(payload))
    const data = camelizeKeys(response.data)
    commit(types.SET_SEARCH_BENEFICIARIES_RESULTS, data.content)
  }catch(error){
    dispatch('setError',{hasError: true, error: 'Error al buscar beneficiarios, por favor intente nuevamente o contacte a su equipo de soporte técnico'})
  }
}

export const searchBeneficiaryBenefits = async ({ commit, dispatch }, beneficiaryId) => {
  commit(types.SET_BENEFICIARY_INFORMATION, null)

  try {
    const response = await plansService.getBeneficiary(beneficiaryId)
    const data = camelizeKeys(response.data)

    commit(types.SET_BENEFICIARY_INFORMATION, data)
  }catch(error){
    dispatch('setError',{
      hasError: true,
      error: 'Error al buscar los beneficios del beneficiario, por favor intente nuevamente o contacte a su equipo de soporte técnico'
    })
  }
}

export const setSelectedBeneficiary = ({ commit }, payload) => {
  commit(types.SET_SELECTED_BENEFICIARY, payload)
}

export const setBeneficiarySearchCompleted = ({ commit }, payload) => {
  commit(types.SET_BENEFICIARY_SEARCH_COMPLETED, payload)
}

export const setSponsorConfiguration = async ({ commit, dispatch }, payload) => {
  try {
    const response = await arcService.getSponsorConfiguration(payload)
    commit(types.SET_SPONSOR_CONFIGURATION, camelizeKeys(response.data))

  }catch(error){
    dispatch('setError', {
      hasError: true,
      error: 'Error al obtener la configuración de la aseguradora'
    })
  }
}

export const voidAuthorizationByCode = async ({commit, dispatch, rootState}, authorizationCode) => {
  commit(types.AUTHORIZATION_LOADING, true)
  
  const tokenExtensions = rootState.auth.tokenExtensions;
  const sponsorSlug = tokenExtensions.sponsorSlug;

  const hasSponsorTranslations = tokenExtensions.sponsorTranslations;
  const messageKey =  hasSponsorTranslations ? sponsorSlug + '.authorizationList.voidDialog.': 'authorizationList.voidDialog.';

  const payload = {
    sponsorSlug,
    authorizationCode
  }

  try {
    await arcService.voidAuthorizationByCode(payload);
    commit(types.AUTHORIZATION_LOADING, false)

    dispatch('general/configureAlert', {
      active: true,
      type: 'success',
      message: vuei18n.t(messageKey + 'success')
    }, {root: true});

  } catch(error) {
    commit(types.AUTHORIZATION_LOADING, false)

    dispatch('general/configureAlert', {
      active: true,
      type: 'error',
      message: vuei18n.t(messageKey + 'error')
    }, {root: true});
  }
}

export const notAttendedAuthorizationByCode = async ({commit, dispatch, rootState}, {authorizationCode, authorizationStatus}) => {
  commit(types.AUTHORIZATION_LOADING, true)
  
  const tokenExtensions = rootState.auth.tokenExtensions;
  const sponsorSlug = tokenExtensions.sponsorSlug;

  const hasSponsorTranslations = tokenExtensions.sponsorTranslations;
  const messageKey =  hasSponsorTranslations ? sponsorSlug + '.authorizationList.notAttendedDialog.': 'authorizationList.notAttendedDialog.';

  const payload = {
    sponsorSlug,
    authorizationCode,
    status: {
      currentStatus: authorizationStatus,
      newStatus: 'NOT_ATTENDED'
    }
  }

  try {
    await arcService.changeStatus(payload);
    commit(types.AUTHORIZATION_LOADING, false)

    dispatch('general/configureAlert', {
      active: true,
      type: 'success',
      message: vuei18n.t(messageKey + 'success')
    }, {root: true});

  } catch(error) {
    commit(types.AUTHORIZATION_LOADING, false)

    dispatch('general/configureAlert', {
      active: true,
      type: 'error',
      message: vuei18n.t(messageKey + 'error')
    }, {root: true});

  }
}

export const configureAlert = ({commit}, payload) => {
  commit(types.CONFIGURE_ALERT, payload)
}
